import { createFileRoute } from '@tanstack/react-router';

import { adsTxtRecordsRouteSearchSchema } from '../features/supply/adsTxt/adsTxtRecordsRouteSearch';
import { AdsTxtRecordsTable } from '../features/supply/adsTxt/components/AdsTxtRecordsTable';

export const Route = createFileRoute('/supply/ads-txt/records')({
  validateSearch: adsTxtRecordsRouteSearchSchema,
  component: AdsTxtRecordsTable,
});
